import { create } from "zustand";
import { UserDto } from "../general/dtos";
import { persist, createJSONStorage } from 'zustand/middleware';

interface ContentLayoutState {
    splitterSizesByPage: Record<string, number[]>;
    setSplitterSizes: (pageId: string, sizes: number[]) => void;
}

export const useContentLayoutStore = create<ContentLayoutState>()(
    persist(
        (set) => ({
            splitterSizesByPage: {},
            setSplitterSizes: (pageId, sizes) =>
                set((state) => ({
                    splitterSizesByPage: {
                        ...state.splitterSizesByPage,
                        [pageId]: sizes
                    }
                }))
        }),
        {
            name: 'content-layout-splitter' // localStorage key
        }
    )
);

interface UserStore {
  user: UserDto | null;
  setUser: (user: UserDto) => void;
  clearUser: () => void;
}

export const useUserStore = create<UserStore>((set) => ({
  user: null,

  setUser: (user) => set({ user }),

  clearUser: () => set({ user: null })
}));

interface AiState {
  // Session-only (Memory)
  responseCache: Record<string, string>; 
  setCacheValue: (key: string, value: string) => void;
  
  // Persisted (LocalStorage)
  preferredLanguage: string;
  setPreferredLanguage: (lang: string) => void;
}

export const useAiStore = create<AiState>()(
  persist(
    (set) => ({
      responseCache: {},
      setCacheValue: (key, value) => 
        set((state) => ({
        responseCache: { ...state.responseCache, [key]: value }
      })),

      preferredLanguage: 'English',
      setPreferredLanguage: (preferredLanguage) => set({ preferredLanguage }),
    }),
    {
      name: 'ai-storage', 
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ preferredLanguage: state.preferredLanguage }),
    }
  )
);